export const error = {
  error404Title: "404",
  error404Description: "Ups! Etwas ist schief gelaufen...",
  error: "Fehler",
  accessDenied: "Zugriff verweigert",
  noPermissions: "Keine Berechtigungen",
  default: "Ups! Etwas ist schief gelaufen. Bitte versuche es später erneut."
};
